exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav[data-v-dcee9c14] {\n  height: 48px;\n  overflow: hidden;\n}\n.nav .item[data-v-dcee9c14] {\n  position: relative;\n  height: 48px;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n}\n.nav .item .bg[data-v-dcee9c14] {\n  position: absolute;\n  width: 18px;\n  height: 3px;\n  border-radius: 2px;\n  left: 50%;\n  bottom: 9px;\n  margin-left: -9px;\n}\n.content[data-v-dcee9c14] {\n  margin-top: 20px;\n}\n", ""]);

// exports
